// Broadcast channel for auth state synchronization
export const authChannel =
  typeof window !== "undefined" ? new BroadcastChannel("auth") : null;

export const broadcastSignOut = () => {
  authChannel?.postMessage({ 
    type: "signout", 
    timestamp: Date.now() 
  });
};

export const broadcastSessionUpdate = (session) => {
  authChannel?.postMessage({ 
    type: "session_update", 
    session,
    timestamp: Date.now() 
  });
};

export const setupAuthListener = (router, sessionUpdate) => {
  if (!authChannel) return;

  const handleAuthMessage = async (event) => {
    const { type, session, timestamp } = event.data;
    
    // Ignore old messages (older than 5 seconds)
    if (Date.now() - timestamp > 5000) return;

    switch (type) {
      case "signout":
        // Clear the session immediately using NextAuth's update mechanism
        if (sessionUpdate) {
          await sessionUpdate(null);
        }
        
        // Clear any remaining auth cookies manually
        const cookiesToClear = [
          "next-auth.session-token",
          "__Secure-next-auth.session-token",
          "next-auth.callback-url",
          "next-auth.csrf-token",
          "__Host-next-auth.csrf-token",
        ];
        
        cookiesToClear.forEach(cookieName => {
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${window.location.hostname}`;
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.${window.location.hostname}`;
          document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
        });
        
        // Force a page reload to ensure all components reset properly
        window.location.href = "/";
        break;
        
      case "session_update":
        // Update session across tabs for impersonation, role changes, etc.
        if (sessionUpdate && session) {
          await sessionUpdate(session);
        }
        break;
    }
  };

  authChannel.onmessage = handleAuthMessage;
};
